import React from 'react'
import { CCol, CFormLabel, CRow } from '@coreui/react-pro'
import moment from 'moment'

const formatDate = (date) => (date ? moment(date).format('MMM D, YYYY h:mm A') : 'Not set')

const SeasonDates = ({ startDate, endDate }) => (
  <CRow>
    <CCol md={12}>
      <CFormLabel className="fw-bold">Season Dates</CFormLabel>
    </CCol>
    <CCol md={6}>
      <CFormLabel htmlFor="season_start_date">Start Date</CFormLabel>
      <input
        type="text"
        id="season_start_date"
        className="form-control"
        value={formatDate(startDate)}
        disabled
        readOnly
      />
    </CCol>
    <CCol md={6}>
      <CFormLabel htmlFor="season_end_date">End Date</CFormLabel>
      <input
        type="text"
        id="season_end_date"
        className="form-control"
        value={formatDate(endDate)}
        disabled
        readOnly
      />
    </CCol>
    <CCol md={12} className="mt-2">
      <small className="text-medium-emphasis">
        The overall period your game will run. This is managed separately and can&apos;t be edited
        here.
      </small>
    </CCol>
  </CRow>
)

export default SeasonDates
